// @ts-strict-ignore
import {Metric, MetricsRequest, MetricsResultsMap} from 'app_api/projects/metrics/types';
import {bulkUpdateMetrics, createMetric, metricsClient, updateMetric} from 'common/report/queries/app-api/metrics';
import {ApiResource} from 'common/util/model-resource/api-resource';

const CREATE_KEY = `create`;

export class MetricsResource extends ApiResource<Metric> {
  apiClient = metricsClient;

  private async requestWrapper(loadingKeys: string[], callback: () => Promise<MetricsResultsMap>) {
    loadingKeys.forEach((key) => this.fetchesInProgress.set(key, undefined));
    this.notifySubscribers();
    try {
      const results = await callback();

      this.update(results, {partialUpdate: false});

      return results;
    } finally {
      loadingKeys.forEach((key) => this.fetchesInProgress.delete(key));
      this.notifySubscribers();
    }
  }

  patch(id: number, metric: Partial<MetricsRequest>): Promise<MetricsResultsMap> {
    const metricId = id.toString();
    return this.requestWrapper([metricId], () => updateMetric({metricId, metric}));
  }

  async bulkPatch(metrics: Array<Partial<Metric>>): Promise<MetricsResultsMap> {
    const metricIds = metrics.map((m) => m.id?.toString() || ``);
    return this.requestWrapper(metricIds, () => bulkUpdateMetrics(metrics));
  }

  create(metric: MetricsRequest): Promise<MetricsResultsMap> {
    return this.requestWrapper([CREATE_KEY], () => createMetric(metric));
  }

  isLoading(id?: number) {
    if (id) {
      return this.fetchesInProgress.has(id.toString());
    }
    return this.fetchesInProgress.has(CREATE_KEY);
  }
}
